module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg0OCAxMjhBNDggNDggMCAwIDEgODk2IDE3NnY2NzJhNDggNDggMCAwIDEtNDggNDhoLTY3MkE0OCA0OCAwIDAgMSAxMjggODQ4di02NzJBNDggNDggMCAwIDEgMTc2IDEyOGg2NzJ6TTgzMiAxOTJIMTkydjY0MGg2NDBWMTkyek01MTIgMjg4YTMyIDMyIDAgMCAxIDMyIDMydjE2MGgxNjBhMzIgMzIgMCAwIDEgMCA2NGgtMTYwdjE2MGEzMiAzMiAwIDAgMS02NCAwdi0xNjBoLTE2MGEzMiAzMiAwIDAgMSAwLTY0aDE2MHYtMTYwYTMyIDMyIDAgMCAxIDMyLTMyeiIgZmlsbD0iIzAiIHAtaWQ9Ijc4NSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Unfolded-outlined.svg
// module id = 63Sa
// module chunks = 74